import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@sylva/shared-types/database';

export type CategoryRow = Tables<'appointment_type_categories'>;

export const fetchCategories = async (tenantId: string): Promise<CategoryRow[]> => {
  const { data, error } = await supabase
    .from('appointment_type_categories')
    .select('*')
    .eq('tenant_id', tenantId)
    .eq('is_active', true)
    .order('display_order', { ascending: true });

  if (error) throw error;
  return data || [];
};